import React from "react";
import { Link } from "react-router-dom";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { FOOTER_LINKS } from "../homeV2.constants";

type FooterLink = { label: string; to?: string; href?: string };

const FooterLinkList = ({ links }: { links: FooterLink[] }) =>
  links.map((link) =>
    link.to ? (
      <Link key={link.label} to={link.to}>
        {link.label}
      </Link>
    ) : (
      <a key={link.label} href={link.href}>
        {link.label}
      </a>
    )
  );

const Footer = () => {
  return (
    <footer className="hv2-footer" id="footer">
      <div className="home-v2__container">
        <div className="hv2-footer__grid">
          <div className="hv2-footer__brand">
            <h3>
              <span className="hv2-logo-icon" aria-hidden="true">
                <PlayArrowIcon fontSize="inherit" />
              </span>
              <span className="hv2-wordmark">
                employ<span>HER</span>
              </span>
            </h3>
            <p>Be seen. Not screened. The AI-powered career OS built for you.</p>
          </div>
          <div className="hv2-footer__col">
            <h4>For Talent</h4>
            <FooterLinkList links={FOOTER_LINKS.talent} />
          </div>
          <div className="hv2-footer__col">
            <h4>For Employers</h4>
            <FooterLinkList links={FOOTER_LINKS.employers} />
          </div>
          <div className="hv2-footer__col">
            <h4>Resources</h4>
            {FOOTER_LINKS.resources.map((label) => (
              <span key={label} className="hv2-footer__inert-link">
                {label}
              </span>
            ))}
          </div>
          <div className="hv2-footer__col">
            <h4>Company</h4>
            <FooterLinkList links={FOOTER_LINKS.company} />
          </div>
        </div>
        <div className="hv2-footer__bottom">
          <span>© {new Date().getFullYear()} employHER. All rights reserved.</span>
          <span className="hv2-footer__tagline">
            empower · inspire · <span>employHER</span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
